module.exports = __webpack_public_path__ + "img/xend mail.6f19bb48.png";